// extracted by mini-css-extract-plugin
module.exports = {"hot-section-title":"style_hot-section-title__fXOUq"};